import { useEffect } from "react";

import { useQueryParamsManager } from "../routing";

import { FOLLOWING_QUERY_PARAM } from "components/constants";
import { useAppSelector } from "store/index";
import { selectCurrentClassUser, selectIsPresentationActive } from "store/selectors";
import { selectIsInBreakout } from "store/selectors/breakouts";

interface UseBreakoutInSessionObserverProps {
  isInVirtualClass: boolean;
}

export const useBreakoutInSessionObserver = ({
  isInVirtualClass,
}: UseBreakoutInSessionObserverProps) => {
  const isInBreakout = useAppSelector(selectIsInBreakout);
  const isPresentationActive = useAppSelector(selectIsPresentationActive);
  const currentClassUser = useAppSelector(selectCurrentClassUser);
  const { deleteQueryParams } = useQueryParamsManager();

  const breakoutGroupId = currentClassUser?.breakout_group_id;

  useEffect(() => {
    if (isInVirtualClass && isInBreakout && !!breakoutGroupId) {
      deleteQueryParams([FOLLOWING_QUERY_PARAM]);
    }
  }, [isInBreakout, isPresentationActive, deleteQueryParams, isInVirtualClass, breakoutGroupId]);
};
